import { render } from "./NewInwardManageBoxes.vue?vue&type=template&id=4414ca88"
import script from "./NewInwardManageBoxes.vue?vue&type=script&lang=js"
export * from "./NewInwardManageBoxes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__